import { customerAPI } from './api';

// Simple phone-based authentication for delivery app
export class DeliveryAuth {
  constructor() {
    this.currentUser = this.getCurrentUser();
  }

  // Get current user from localStorage
  getCurrentUser() {
    const userStr = localStorage.getItem('deliveryUser');
    return userStr ? JSON.parse(userStr) : null;
  }

  // Set current user
  setCurrentUser(user) {
    this.currentUser = user;
    if (user) {
      localStorage.setItem('deliveryUser', JSON.stringify(user));
    } else {
      localStorage.removeItem('deliveryUser');
    }
  }

  // Check if user is logged in
  isLoggedIn() {
    return !!this.currentUser;
  }

  // Login with phone number (checks if customer exists)
  async login(phone) {
    try {
      const result = await customerAPI.getByPhone(phone);
      const customer = result.data;
      
      this.setCurrentUser({
        id: customer.id,
        name: customer.name,
        phone: customer.phone,
        email: customer.email,
        address: customer.address
      });

      return { success: true, user: this.currentUser };
    } catch (error) {
      console.error('Login failed:', error);
      return { success: false, error: 'Customer not found. Please sign up first.' };
    }
  }

  // Sign up new customer
  async signUp(customerData) {
    try {
      // Check if customer already exists
      try {
        await customerAPI.getByPhone(customerData.phone);
        return { success: false, error: 'Customer already exists. Please login instead.' };
      } catch (error) {
        // Customer doesn't exist, continue with signup
      }

      // Create new customer
      const result = await customerAPI.create(customerData);
      const customer = result.data;

      this.setCurrentUser({
        id: customer.id,
        name: customer.name,
        phone: customer.phone,
        email: customer.email,
        address: customer.address
      });

      return { success: true, user: this.currentUser };
    } catch (error) {
      console.error('Signup failed:', error);
      return { success: false, error: 'Failed to create account. Please try again.' };
    }
  }

  // Continue as guest (no account creation)
  continueAsGuest(guestData) {
    this.setCurrentUser({
      id: 'guest',
      name: guestData.name,
      phone: guestData.phone,
      email: guestData.email || '',
      address: guestData.address,
      isGuest: true
    });

    return { success: true, user: this.currentUser };
  }

  // Update user profile
  async updateProfile(userData) {
    if (!this.currentUser || this.currentUser.isGuest) {
      return { success: false, error: 'No user logged in' };
    }

    try {
      await customerAPI.update(this.currentUser.id, userData);
      
      this.setCurrentUser({
        ...this.currentUser,
        ...userData
      });

      return { success: true, user: this.currentUser };
    } catch (error) {
      console.error('Profile update failed:', error);
      return { success: false, error: 'Failed to update profile' };
    }
  }

  // Logout
  logout() {
    this.setCurrentUser(null);
    return { success: true };
  }
}

// Create singleton instance
export const deliveryAuth = new DeliveryAuth();